export enum traceTypes {
    TRACE_DATA = 'TRACE_DATA'
}